<template>
  <div
    class="product-cards--golf__card"
    :class="{
      'product-cards--golf__card--open': cardOpen,
      'product-cards--golf__card--no-times': inventoryItemsCount < 1,
    }"
    :data-course-id="this.product.Sku"
  >
    <loading-animation type="spinner" v-show="cardLoading"></loading-animation>
    <div
      class="product-cards--golf__card--wrapper"
      :class="{
        'product-cards--golf__card--loading': cardLoading,
      }"
    >
      <div
        :style="{ backgroundImage: 'url(' + getThumbnail(product) + ')' }"
        class="product-thumbnail"
        :class="{ 'ax--animation--fade-in--move-down': cardOpen }"
        v-on:click="openCard"
      >
        <div class="product-name" v-if="!cardOpen">
          <h3 class="ax--text_14Sm">{{ product.Name | clubName }}</h3>
          <h4 class="ax--text_18Sm ax--text_20Md">{{ product.Name | courseName }}</h4>
        </div>
      </div>

      <transition name="fade--up" leave-active-class="instant-hide">
        <div class="product-information--open" v-if="cardOpen">
          <ax-button
            label="Back to Courses"
            button-type="ghost"
            icon="arrow-left"
            icon-position="left"
            width="auto"
            v-on:click="closeCard"
          ></ax-button>
          <div class="ax--box">
            <div class="product-name">
              <h4>{{ product.Name | clubName }}</h4>
              <h3 class="ax--text ax--text_28Lg ax--text_24">{{ product.Name | courseName }}</h3>
            </div>
            <p v-html="product.ShortDescription" />
            <div class="product-information__note ax--text_14Sm">
              <p class="product-information__note ax--text_14Sm" v-if="courseNote" v-html="courseNote"></p>
            </div>
            <div class="product-information__pricing">
              <div class="ax--text_14Sm ax--text_capitalize">Starting at (per player)</div>
              <div class="price ax--text_28 ax--text_38Lg">{{ lowestPrice | currency }}</div>
              <p class="savings ax--text_14 ax--text_capitalize" v-if="savePercent">
                {{ savePercent | displayPercent }} Savings
              </p>
            </div>
          </div>
        </div>
      </transition>

      <div class="product-information" v-on:click="openCard" v-if="!cardOpen">
        <div class="product-information__description" v-if="inventoryItemsCount > 0">
          <p v-html="product.ShortDescription" />
          <p class="product-information__note ax--text_14Sm" v-if="courseNote" v-html="courseNote"></p>
        </div>

        <div class="product-information__inventory-info">
          <template v-if="inventoryItemsCount > 0">
            <div class="product-information__pricing" v-if="lowestPrice">
              <div class="ax--text_14Sm ax--text_capitalize">Starting at (per player)</div>
              <p class="price">{{ lowestPrice | currency }}</p>
              <p class="savings ax--text_14 ax--text_capitalize" v-if="savePercent">
                {{ savePercent | displayPercent }} Savings
              </p>
            </div>
            <div class="product-information__pricing" v-if="inventoryItemsCount">
              <div class="ax--text_14Sm">Tee Times ({{ inventoryItemsCount }})</div>
              <p class="tee-times">{{ earliestTime | formattedTime }} - {{ latestTime | formattedTime }}</p>
              <ax-button
                id="btn-view-tee-times"
                button-type="ghost"
                :label="teeTimesLabel"
                icon="arrow-right"
                icon-position="right"
                @click="openCard"
              />
            </div>
          </template>
          <template v-else>
            <div class="product-information__pricing">
              <p class="tee-times"> {{ inventoryMessageTitle }}</p>
              <p class="tee-times" v-if="inventoryMessageBody"> {{ inventoryMessageBody }}</p>
            </div>
          </template>
        </div>
      </div>

      <ProductInventoryGolf
        v-model="inventoryItems"
        v-on:item-selected="reserveInventoryItem"
        v-on:items-changed="inventoryItemsChanged"
        v-show="cardOpen"
        v-if="inventoryItems"
      />

      <portal to="modal-container" v-cloak>
        <ax-modal v-if="showModal" class="golf__modal--book" size="medium" @close="closeModal">
          <div slot="header">
            <h3 class="ax--text_24Sm">{{ product.Name }}</h3>
            <div class="golf__modal--book__date-time">
              <div class="ax--text_16Sm">{{ displayDate }}</div>
              <div class="ax--text_16Sm">{{ selectedItemTimeDisplay }}</div>
            </div>
          </div>

          <div slot="body" class="ax--box full-width">
            <label for="players" class="ax--input__label ax--input__label--center">Number Of Players</label>
            <ul class="ax--radio-group player-count" name="players">
              <li class="ax--radio-btn__wrapper">
                <input
                  type="radio"
                  class="ax--radio-btn__input"
                  name="nbr-players"
                  value="1"
                  v-model="quantity"
                  id="attr-nbr-players--1"
                />
                <ax-button label="1" v-on:click="quantity = 1" :disabled="selectedItemMaxPlayers < 1"></ax-button>
              </li>
              <li class="ax--radio-btn__wrapper">
                <input
                  type="radio"
                  class="ax--radio-btn__input"
                  name="nbr-players"
                  value="2"
                  v-model="quantity"
                  id="attr-nbr-players--2"
                />
                <ax-button label="2" v-on:click="quantity = 2" :disabled="selectedItemMaxPlayers < 2"></ax-button>
              </li>
              <li class="ax--radio-btn__wrapper">
                <input
                  type="radio"
                  class="ax--radio-btn__input"
                  name="nbr-players"
                  value="3"
                  v-model="quantity"
                  id="attr-nbr-players--3"
                />
                <ax-button label="3" v-on:click="quantity = 3" :disabled="selectedItemMaxPlayers < 3"></ax-button>
              </li>
              <li class="ax--radio-btn__wrapper">
                <input
                  type="radio"
                  class="ax--radio-btn__input"
                  name="nbr-players"
                  value="4"
                  v-model="quantity"
                  id="attr-nbr-players--4"
                />
                <ax-button label="4" v-on:click="quantity = 4" :disabled="selectedItemMaxPlayers < 4"></ax-button>
              </li>
            </ul>
          </div>

          <div slot="footer">
            <ax-label
              :label="cartError"
              align="center"
              class="ax--label--error ax--text_14 ax--text_16Md"
              v-if="cartError"
            />
            <p class="product-information__note ax--text_14Sm" v-if="courseNote" v-html="courseNote"></p>
            <div class="ax--modal-footer__buttons">
              <ax-button :label="addToCartLabel" size="LG" @click="addToCart" :show-loader="addingToCart"></ax-button>
            </div>
            <ax-label
              :label="`$0 Due Online / ${this.$options.filters.currency(this.purchasePrice)} Due On Arrival`"
              align="center"
              class="ax--text_14 ax--text_16Md"
            />
          </div>
        </ax-modal>
      </portal>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import numeral from 'numeral'
import { mapGetters } from 'vuex'
import ProductInventoryGolf from './productInventory-golf'
import FormInput from '@/components/form/form-input'
import FormSelect from '@/components/form/form-select'
import { CartUtils } from '@/mixins/cart-utils'
import LoadingAnimation from '@/components/loading-animation'
import sampleInventory from '../../data/sample-inventory.json'

export default {
  name: 'ProductCard-golf',

  components: {
    ProductInventoryGolf,
    FormInput,
    FormSelect,
    LoadingAnimation,
  },

  filters: {
    clubName(n) {
      return n.includes('-') ? n.split(' - ')[0] : null
    },
    courseName(n) {
      return n.includes('-') ? n.split(' - ')[1] : n
    },
    currency(n) {
      // TODO: Make this locale specific
      // This formatting will remove the cents (decimals) if zero
      return numeral(n).format('$0,0[.]00')
    },
    displayPercent(percentValue) {
      return `${Math.round(percentValue)}%`
    },
    formattedTime(n) {
      if (n.toString().includes(':')) {
        const momentTime = moment(n, 'hh:mm:ss a')
        return momentTime.format('h:mma')
      } else {
        const time = n.toString()
        const seconds = time.substring(time.length - 2, time.length)
        const minute = time.substring(time.length - 4, time.length - 2)
        const hour = time.substring(0, time.length - 4)
        const formattedHour = hour > 12 ? hour - 12 : hour
        const amPm = hour > 11 ? 'pm' : 'am'
        return `${formattedHour}:${minute}${amPm}`
      }
    },
  },

  mixins: [CartUtils],

  props: {
    product: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      requests: {},
      cancelSource: null,
      inventoryCancelToken: null,
      inventoryItems: null,
      addingToCart: false,
      cartError: null,
      cardOpen: false,
      cardLoading: false,
      description: '',
      formattedDescription: '',
      showModal: false,
      nbrPlayers: 1,
      quantity: 1,
      inventoryItemsCount: null,
      lowestPrice: null,
      saveAmount: null,
      savePercent: null,
      originalPriceValue: null,
      earliestTime: null,
      latestTime: null,
      selectedItemMaxPlayers: 4,
      selectedItemTimeDisplay: null,
      sampleInventory,
      inventoryMessageTitle: '',
      inventoryMessageBody: '',
    }
  },

  computed: {
    courseNote() {
      if (this.product && this.product.ProductSpecifications) {
        const attr = this.product.ProductSpecifications.find(
          (attr) => attr.SpecificationAttributeName === 'Course Note'
        )
        return attr ? attr.ValueRaw : null
      }

      // If this course doesnt contain a note
      return null
    },
    customerPriceAttributeId() {
      return `addtocart_${this.product.Id}.CustomerEnteredPrice`
    },
    productDetailsFormName() {
      return `product-details-form-${this.product.Id}`
    },
    addToCartLabel() {
      return `Add To Cart<span class='ax--btn__divider'>|</span>${this.$options.filters.currency(this.purchasePrice)}`
    },
    purchasePrice() {
      return this.priceValue * this.quantity
    },
    dateAttribute() {
      return this.product ? this.product.ProductAttributes.find((attr) => attr.IsDate) : null
    },
    teeTimesLabel() {
      // If the tee times label includes the number of tee times as a variable, replace with the count
      return this.labels.Golf.Catalog.ViewTeeTimes.replace('${inventoryItemsCount}', this.inventoryItemsCount)
    },
    timeAttribute() {
      return this.product ? this.product.ProductAttributes.find((attr) => attr.Name === 'Reservation Time') : null
    },
    holesAttribute() {
      return this.product ? this.product.ProductAttributes.find((attr) => attr.Name === 'Reservation Holes') : null
    },
    priceAttribute() {
      return this.product ? this.product.ProductAttributes.find((attr) => attr.Name === 'Reservation Price') : null
    },
    customerPriceAttribute() {
      return {
        Name: 'Price',
        Id: `addtocart_${this.product.ProductId}.CustomerEnteredPrice`,
        IsCustomerEnteredPrice: true,
      }
    },
    dateValue() {
      if (this.dateAttribute) {
        return this.dateAttribute.SelectedValue || this.dateAttribute.SelectedValueId
      }

      return null
    },
    timeValue() {
      if (this.timeAttribute) {
        return this.timeAttribute.SelectedValue || this.timeAttribute.SelectedValueId
      }

      return null
    },
    holesValue() {
      if (this.holesAttribute) {
        return this.holesAttribute.SelectedValue || this.holesAttribute.SelectedValueId
      }

      return null
    },
    priceValue() {
      if (this.priceAttribute) {
        return this.priceAttribute.SelectedValue || this.priceAttribute.SelectedValueId
      }

      return null
    },
    displayDate() {
      if (this.dateAttribute && this.dateAttribute.SelectedValueId) {
        return moment(this.dateValue).format('LL')
      }
    },
    displayTime() {
      return this.$options.filters.formattedTime(this.timeValue) || 'NO TIME'
    },
    availablePlayers() {
      return [
        {
          Value: 1,
          Text: '1',
          Hidden: false,
          Selected: true,
        },
        {
          Value: 2,
          Text: '2',
          Hidden: false,
          Selected: false,
        },
        {
          Value: 3,
          Text: '3',
          Hidden: false,
          Selected: false,
        },
        {
          Value: 4,
          Text: '4',
          Hidden: false,
          Selected: false,
        },
      ]
    },
    availableProductQuantities() {
      let playerQuantities = this.availablePlayers.map((item) => {
        return {
          value: item.Value,
          name: item.Text,
          hidden: item.Hidden,
          isPreSelected: item.Selected,
        }
      })

      return playerQuantities
    },

    ...mapGetters({
      filterDate: 'filters/date',
      filterFirstAvailableDate: 'filters/firstAvailableDate',
      filterHoles: 'filters/holes',
      filterPlayers: 'filters/players',
      labels: 'global/labels',
    }),
  },

  watch: {
    showModal(toValue) {
      if (toValue) {
        document.body.classList.add('ax--modal--open')
      } else {
        document.body.classList.remove('ax--modal--open')
      }
    },
    filterDate: {
      immediate: true,
      handler(toDate) {
        this.dateChanged(toDate)
        this.$nextTick(() => {
          this.fetchInventoryItems()
        })
      },
    },
    filterHoles: {
      immediate: false,
      handler(toHoles, fromHoles) {
        if (toHoles !== fromHoles) {
          this.$nextTick(() => {
            this.fetchInventoryItems()
          })
        }
      },
    },
    filterPlayers: {
      immediate: true,
      handler(toPlayers) {
        this.playerChanged(toPlayers)
      },
    },
  },

  methods: {
    openCard() {
      if (!this.cardOpen) {
        this.cardOpen = true
      }
    },
    closeCard() {
      if (this.cardOpen) {
        this.cardOpen = false
      }
    },
    async addToCart() {
      this.addingToCart = true

      try {
        const result = await this.$store.dispatch('cart/addToCart', {
          productId: this.product.Id,
          productAttributes: this.product.ProductAttributes,
          productCustomPrice: this.customerPriceAttribute.SelectedValue,
          productQuantity: this.quantity,
        })

        this.closeModal()
        this.getCartData(null, true, () => {
          this.onCartReload()
          if (result.success) this.$store.dispatch('cart/saveAndSendGA4AddToCartEvent')
        })
      } catch (error) {
        this.cartError = error.response.data.message[0]
      } finally {
        this.addingToCart = false
      }
    },
    onCartReload: function () {
      var scrollToElement = $('#commerce-store')
      var container = $('body, html')
      // TODO: Do I need to reset something with this product?
      // this.resetProduct()
      container.animate({
        scrollTop: scrollToElement.offset().top,
      })
    },
    inventoryItemsChanged(inventorySummaryData) {
      this.lowestPrice = inventorySummaryData.lowestPrice
      this.savePercent = inventorySummaryData.lowestPriceSavePercent
      this.saveAmount = inventorySummaryData.lowestPriceSaveAmount
      this.originalPriceValue = this.lowestPrice + this.saveAmount
      this.earliestTime = inventorySummaryData.earliestTime
      this.latestTime = inventorySummaryData.latestTime
      this.inventoryItemsCount = inventorySummaryData.count
    },
    closeModal(eventValue) {
      this.showModal = false
      this.cartError = null

      // Reset tee time attributes
      this.resetTeeTimeAttributes()
    },
    dateChanged(toDate) {
      const newDate = moment(toDate)
      const month = newDate.month() + 1 // Date is zero based and we need the actual month number
      const day = newDate.date()
      const year = newDate.year()
      const dateList = [new Date(newDate)]
      const shortDate = newDate.format('L')
      if (this.dateAttribute) {
        this.$set(this.dateAttribute, 'SelectedMonth', month)
        this.$set(this.dateAttribute, 'SelectedDay', day)
        this.$set(this.dateAttribute, 'SelectedYear', year)
        this.$set(this.dateAttribute, 'SelectedDates', dateList)
        this.$set(this.dateAttribute, 'SelectedValueId', shortDate)
      }
    },
    fetchInventoryItems() {
      const inventoryItemsUrl = `/api/product/iteminventory?teetimeDate=${this.filterDate}&productId=${this.product.Id}&holes=${this.filterHoles}`

      if (this.inventoryCancelToken) {
        this.inventoryCancelToken.cancel(
          `Fetch inventory for [${this.product.Id}] cancelled after selecting a new date`
        )
      }

      this.inventoryCancelToken = axios.CancelToken.source()
      this.cardLoading = true
      this.inventoryItems = null

      this.$store
        .dispatch(
          'api/get',
          {
            url: inventoryItemsUrl,
            cancelToken: this.inventoryCancelToken.token,
          },
          {
            root: true,
          }
        )
        .then((res) => {
          this.$emit('inventory-loaded', `${this.filterDate}/${this.product.Id}`)
          this.inventoryItems = res.InventoryItems
          this.product.HasInventory = this.inventoryItems.length > 0
          this.inventoryMessageTitle = res.InventoryMessageTitle
          this.inventoryMessageBody = res.InventoryMessageBody
          this.cardLoading = false
        })
        .catch((error) => {
          if (!axios.isCancel(error)) {
            this.cardLoading = false
          }
        })
    },
    playerChanged(toPlayers) {
      if (parseInt(toPlayers)) {
        this.$set(this, 'quantity', toPlayers)
      } else {
        this.$set(this, 'quantity', 1)
      }
    },
    getThumbnail(n) {
      return this.product.PictureModels[0].ThumbImageUrl
    },
    reserveInventoryItem(item) {
      // Set time value
      if (this.timeAttribute) {
        this.$set(this.timeAttribute, 'SelectedValue', item.time.toLowerCase())
      }
      // Set time value
      if (this.holesAttribute) {
        this.$set(this.holesAttribute, 'SelectedValue', `${item.holes} holes`)
      }
      // Set price value
      if (item.price % 1 === 0) {
        item.price = `${item.price}.00`
      }
      if (this.priceAttribute) {
        this.$set(this.priceAttribute, 'SelectedValue', item.price)
      }
      if (this.customerPriceAttribute) {
        this.$set(this.customerPriceAttribute, 'SelectedValue', item.price)
      }
      // Set time value
      this.selectedItemTimeDisplay = item.timeDisplay.toLowerCase()
      this.selectedItemMaxPlayers = parseInt(item.maxPlayers)

      this.showModal = true
    },
    resetTeeTimeAttributes() {
      if (this.timeAttribute) {
        this.$set(this.timeAttribute, 'SelectedValue', null)
      }
      // Set time value
      if (this.holesAttribute) {
        this.$set(this.holesAttribute, 'SelectedValue', null)
      }
      // Set time value
      if (this.priceAttribute) {
        this.$set(this.priceAttribute, 'SelectedValue', null)
      }
      this.quantity = this.filterPlayers === 'any' ? 1 : this.filterPlayers
      this.selectedItemMaxPlayers = 4
    },
  },

  created() {
    this.description = this.product.FormattedShortDescription
    const CancelToken = axios.CancelToken
  },
}
</script>
